var convert = require('./convert'),
    func = convert('take', require('../take'));

func.placeholder = require('./placeholder');
module.exports = func;



/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/lodash/fp/take.js
 ** module id = 1687
 ** module chunks = 0
 **/